
import { NewModal } from '@/utils/modal'
import { markRaw } from 'vue'
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

type ModalState = 'init' | 'opened' | 'closed'

@Options({})

export default class ModalCenterScreenPage extends Vue {
  @Prop({ required: true, type: Object }) readonly modal!: NewModal
  @Prop({ required: true, type: Function }) readonly removeModal!: (modal: NewModal) => void

  state: ModalState = 'init'
  dynamicComponent: any = null

  created() {
    this.dynamicComponent = markRaw(this.modal.component)
  }

  mounted() {
    // wait for the initial render so the open transition can run
    requestAnimationFrame(() => {
      this.state = 'opened'
    })
  }

  onClose() {
    this.state = 'closed'

    setTimeout(() => {
      this.removeModal(this.modal)
    }, 300)
  }

  onCloseByOutsideClick() {
    if (this.modal.allowedClickOutSide) {
      this.onClose()
    }
  }
}
